type HapticKind = "move" | "rotate" | "lock" | "clear" | "tetris" | "over";

const PATTERNS: Record<HapticKind, number | number[]> = {
  move: 8,
  rotate: 10,
  lock: 16,
  clear: [12, 28, 18],
  tetris: [18, 36, 18, 36, 28],
  over: [40, 50, 80],
};

export function haptic(kind: HapticKind): void {
  if (typeof navigator === "undefined" || !navigator.vibrate) return;
  try {
    navigator.vibrate(PATTERNS[kind]);
  } catch {
    // Destek yoksa sessizce geç
  }
}
